import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'policy-kolton-en',
    templateUrl: './policy-kolton-en.component.html',
    styleUrls: ['./policy-kolton-en.component.scss']
})
export class PolicyKoltonEnComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
